<template>
  <div id="itineraries" :class="{ loading: isLoading }">
    <h3>Itineraries</h3>
    <Tabs v-if="!isLoading && itineraries.length > 1" v-bind="$attrs" :itinerary-index="+itineraryIndex" :itineraries="itineraries" @update:itinerary-index="$emit('update:itineraryIndex', $event)" />
    <Itinerary v-for="(itinerary, i) in itineraries" v-show="!isLoading && itineraryIndex == itinerary.index" v-bind="$attrs" :key="i" :is-visible="!isLoading && itineraryIndex == itinerary.index" :appendix-accommodations="appendixAccommodations" :appendix-flights="appendixFlights" :appendix-transports="appendixTransports" :itinerary="itinerary" :is-hide-prices="isHidePrices" :trip-id="tripId" @print-itinerary="$emit('printItinerary')" @print-receipt="$emit('printReceipt')" />
    <Welcome v-if="itineraries.length == 0 && !isLoading" :trip="props.trip" />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import Itinerary from "./ItinerarySingle.vue";
import Tabs from "./ItinerariesTabs.vue";
import Welcome from "./ItineraryWelcome.vue";
import useApi from "../../utils/apiCalls.js";

const props = defineProps(["isReloadItineraries", "itineraryIndex", "tripId", "trip"]);
const emit = defineEmits(["error", "printReceipt", "printItinerary", "update:isReloadItineraries", "update:itineraryIndex"]);

const appendixAccommodations = ref([]);
const appendixFlights = ref([]);
const appendixTransports = ref([]);
const isHidePrices = ref(false);
const isLoading = ref(true);
const itineraries = ref([]);

const { apiGetRequest } = useApi(emit);

watch(
  () => props.itineraryIndex,
  val => index(val)
);

watch(
  () => props.isReloadItineraries,
  val => {
    if (val === true) {
      load();
      emit("update:isReloadItineraries", false);
    }
  }
);

// Handle mounting
onMounted(() => {
  load();
});

function index(index) {
  if (itineraries.value.length === 0) return;

  if (index) {
    const it = itineraries.value.find(itinerary => String(itinerary.index) === String(index));
    if (it) return;
  }

  //none selected or invalid, find the best one to show
  let bookedIndex, canceledIndex;
  let lastIndex = itineraries.value[0].index;
  for (let i = 0; i < itineraries.value.length; i++) {
    if (!bookedIndex && itineraries.value[i].isBooked === true) {
      bookedIndex = itineraries.value[i].index;
    }
    if (!canceledIndex && itineraries.value[i].isCanceled === true) {
      canceledIndex = itineraries.value[i].index;
    }
    if ((itineraries.value[i].quotes !== null && itineraries.value[i].quotes.length > 0) || itineraries.value[i].totalCost > 0) {
      lastIndex = itineraries.value[i].index;
    }
  }

  // use booked index if available
  // otherwise use canceled index if available
  // otherwise use last index
  const showIndex = bookedIndex || canceledIndex || lastIndex;
  if (String(showIndex) !== String(props.itineraryIndex)) {
    emit("update:itineraryIndex", showIndex);
  }
}

// Load itineraries
function load() {
  isLoading.value = true;

  const path = `/trips/${props.tripId}/itineraries`;

  apiGetRequest({
    path,
    onSuccess: data => {
      itineraries.value = data.itineraries;
      appendixAccommodations.value = data.appendixAccommodations;
      appendixFlights.value = data.appendixFlights;
      appendixTransports.value = data.appendixTransports;
      isHidePrices.value = data.isHidePrices;

      index(props.itineraryIndex);
      isLoading.value = false;
    },
    onError: error => {
      isLoading.value = false;
      emit("error", error);
    },
  });
}
</script>

<style lang="less">
#receipt {
  display: none;
}
</style>
